import {
	LuIcon,
	Menu,
	type MenuClickTriggerProps,
	type MenuMultiSelectGroupProps,
	type MenuRootProps,
	type MenuVariantProps,
} from "@overmap-ai/blocks"
import { memo, type ReactElement } from "react"

import { FORM_SUBMISSION_TIMELINE_ITEM_TYPES } from "../../constants"
import { FormSubmissionTimelineItemType } from "../../enums/forms"
import { formSubmissionTimelineItemTypeData } from "../../mappings/forms"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

interface FormSubmissionTimelineItemTypeMultiSelectDropdownProps
	extends
		MenuRootProps,
		MenuMultiSelectGroupProps<FormSubmissionTimelineItemType>,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const FormSubmissionTimelineItemTypeMultiSelectDropdown =
	memo<FormSubmissionTimelineItemTypeMultiSelectDropdownProps>((props) => {
		const { children, disabled, variant, size, accentColor, values, onValuesChange, defaultValues, ...rest } = props

		return (
			<Menu.Root {...rest}>
				<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
				<Menu.Content variant={variant} size={size} accentColor={accentColor}>
					<Menu.MultiSelectGroup<FormSubmissionTimelineItemType>
						defaultValues={defaultValues}
						values={values}
						onValuesChange={onValuesChange}
					>
						<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
						{FORM_SUBMISSION_TIMELINE_ITEM_TYPES.map((type) => {
							const { icon, label } = formSubmissionTimelineItemTypeData[type]

							return (
								<MultiSelectItemTemplate<FormSubmissionTimelineItemType> key={type} value={type}>
									<LuIcon icon={icon} />
									{label}
								</MultiSelectItemTemplate>
							)
						})}
					</Menu.MultiSelectGroup>
				</Menu.Content>
			</Menu.Root>
		)
	})
FormSubmissionTimelineItemTypeMultiSelectDropdown.displayName = "FormSubmissionTimelineItemTypeMultiSelectDropdown"
